import { Link } from 'react-router-dom'

import { deconnecter } from '../auth/connexion'
import type { Profil } from '../lib/profils'

/** Bandeau commun aux pages connectees. */
export function Entete({ profil }: { profil: Profil }) {
  return (
    <header className="border-b border-slate-200 bg-white">
      {/* Filet marine : decoratif, il ne porte aucun texte. */}
      <div className="h-1 bg-marque-accent" aria-hidden="true" />
      <div className="mx-auto flex max-w-5xl flex-wrap items-center gap-4 px-6 py-4">
        <Link to="/" className="text-lg font-semibold text-slate-900">
          Dossiers CV
        </Link>

        <nav className="flex items-center gap-4 text-sm">
          {profil.role === 'admin' ? (
            <Link
              to="/administration"
              data-test="lien-administration"
              className="font-medium text-marque-primaire-texte hover:text-marque-primaire-survol"
            >
              Administration
            </Link>
          ) : null}
        </nav>

        <div className="ml-auto flex items-center gap-4 text-sm">
          <span data-test="courriel-connecte" className="text-slate-600">
            {profil.email}
          </span>
          <button
            type="button"
            data-test="bouton-deconnexion"
            onClick={() => void deconnecter()}
            className="rounded border border-slate-300 px-3 py-1 font-medium text-slate-700 hover:bg-slate-100"
          >
            Se déconnecter
          </button>
        </div>
      </div>
    </header>
  )
}
